import React, { useEffect, useState } from 'react';
import ProjectCard from '../ProjectCard/ProjectCard';

const HTML = () => {
    const [data, setData] = useState([]);
    useEffect(() => {
        fetch('https://stormy-mesa-29040.herokuapp.com/getProjects?category=HTML/CSS')
            .then(res => res.json())
            .then(data => setData(data))
            .catch(err => {
                alert(err);
            })
    }, [])

    return (
        <div className="all-project-section">
            {
                data.length === 0 &&
                <section className="d-flex flex-column justify-content-center align-items-center">
                    <div class="loader"></div>
                    <span className="loading">Loading</span>
                </section>
            }
            {
                data.map(project => <ProjectCard data={project} />)
            }
        </div>
    );
};

export default HTML;